(function () {
  function initKvp5(root) {
    if (!root || root.dataset.kvp5Bound === 'true') return;
    root.dataset.kvp5Bound = 'true';
    
      
      
      
      

      var track = root.querySelector('[data-kvp5-track]');
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-kvp5-card][data-has-alt="true"]'));
      var mqMobile = window.matchMedia('(max-width: 639px)');
      var reduceMotion = false;

      var desktopStartDelay = Number(root.dataset.kvp5StartDelay || 0);
      var desktopStaggerDelay = Number(root.dataset.kvp5StaggerDelay || 0);
      var mobileScrollCooldown = Number(root.dataset.kvp5ScrollCooldown || 0);

      try {
        reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      } catch(e) {
        reduceMotion = false;
      }

      function animateCard(card){
        if(!card || reduceMotion || !card.hasAttribute('data-has-alt')) return;
        card.classList.remove('is-animating');
        void card.offsetWidth;
        card.classList.add('is-animating');

        window.setTimeout(function(){
          card.classList.remove('is-animating');
        }, Number(root.dataset.kvp5AnimDuration || 0) + 40);
      }

      function animateCardsStaggered(list){
        list.forEach(function(card, index){
          window.setTimeout(function(){
            animateCard(card);
          }, index * desktopStaggerDelay);
        });
      }

      var forms = root.querySelectorAll('[data-kvp5-cart-form]');
      forms.forEach(function(form){
        form.addEventListener('submit', function(e){
          e.preventDefault();

          var btn = form.querySelector('[data-kvp5-add]');
          if(!btn || btn.classList.contains('is-loading')) return;

          var defaultText = btn.getAttribute('data-default-text') || btn.textContent;
          var addedText = btn.getAttribute('data-added-text') || defaultText;

          btn.classList.add('is-loading');

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body: new FormData(form)
          })
          .then(function(res){
            if(!res.ok) throw new Error('add failed');
            return res.json();
          })
          .then(function(){
            btn.textContent = addedText;
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            window.dispatchEvent(new CustomEvent('cart:refresh'));
            window.setTimeout(function(){
              btn.textContent = defaultText;
              btn.classList.remove('is-loading');
            }, 1600);
          })
          .catch(function(){
            btn.classList.remove('is-loading');
            btn.textContent = defaultText;
          });
        });
      });

      if(reduceMotion || !cards.length) return;

      var sectionAnimatedDesktop = false;
      var sectionAnimatedMobile = false;
      var desktopAnimationTimer = null;
      var activeCard = null;
      var sectionObserver = null;
      var mobileObserver = null;
      var scrollTicking = false;
      var boundScrollHandler = null;
      var lastMobileAnimationAt = 0;

      function getTrackCenterCard(){
        if(!track || !cards.length) return null;

        var trackRect = track.getBoundingClientRect();
        var trackCenter = trackRect.left + (trackRect.width / 2);
        var bestCard = null;
        var bestDistance = Infinity;

        cards.forEach(function(card){
          var rect = card.getBoundingClientRect();
          var center = rect.left + (rect.width / 2);
          var distance = Math.abs(center - trackCenter);
          if(distance < bestDistance){
            bestDistance = distance;
            bestCard = card;
          }
        });

        return bestCard;
      }

      function setActiveCard(card, animate){
        if(!card) return;

        var now = Date.now();

        if(activeCard === card){
          return;
        }

        activeCard = card;

        if(animate){
          if(now - lastMobileAnimationAt < mobileScrollCooldown) return;
          lastMobileAnimationAt = now;
          animateCard(card);
        }
      }

      function clearDesktopTimer(){
        if(desktopAnimationTimer){
          window.clearTimeout(desktopAnimationTimer);
          desktopAnimationTimer = null;
        }
      }

      function initDesktopObserver(){
        if(sectionObserver) sectionObserver.disconnect();
        clearDesktopTimer();

        sectionObserver = new IntersectionObserver(function(entries){
          entries.forEach(function(entry){
            if(sectionAnimatedDesktop) return;

            if(entry.isIntersecting){
              clearDesktopTimer();
              desktopAnimationTimer = window.setTimeout(function(){
                if(sectionAnimatedDesktop) return;
                sectionAnimatedDesktop = true;
                animateCardsStaggered(cards);
              }, desktopStartDelay);
            } else {
              clearDesktopTimer();
            }
          });
        }, {
          threshold: 0,
          rootMargin: '0px 0px -48% 0px'
        });

        sectionObserver.observe(root);
      }

      function onTrackScroll(){
        if(scrollTicking) return;
        scrollTicking = true;

        window.requestAnimationFrame(function(){
          var centerCard = getTrackCenterCard();
          if(centerCard){
            setActiveCard(centerCard, true);
          }
          scrollTicking = false;
        });
      }

      function initMobileBehavior(){
        if(!track) return;

        if(mobileObserver) mobileObserver.disconnect();

        mobileObserver = new IntersectionObserver(function(entries){
          entries.forEach(function(entry){
            if(entry.isIntersecting){
              if(!sectionAnimatedMobile){
                sectionAnimatedMobile = true;
                var centerCard = getTrackCenterCard();
                if(centerCard){
                  setActiveCard(centerCard, true);
                } else {
                  setActiveCard(entry.target, true);
                }
              }
            }
          });
        }, {
          root: null,
          threshold: 0,
          rootMargin: '0px 0px -48% 0px'
        });

        if(cards[0]) {
          mobileObserver.observe(cards[0]);
        }

        boundScrollHandler = onTrackScroll;
        track.addEventListener('scroll', boundScrollHandler, { passive: true });

        window.requestAnimationFrame(function(){
          var centerCard = getTrackCenterCard();
          if(centerCard){
            setActiveCard(centerCard, false);
          }
        });
      }

      function destroyMobileBehavior(){
        if(mobileObserver) {
          mobileObserver.disconnect();
          mobileObserver = null;
        }
        if(track && boundScrollHandler){
          track.removeEventListener('scroll', boundScrollHandler);
        }
        boundScrollHandler = null;
        activeCard = null;
        lastMobileAnimationAt = 0;
      }

      function handleMode(){
        destroyMobileBehavior();
        if(sectionObserver) {
          sectionObserver.disconnect();
          sectionObserver = null;
        }
        clearDesktopTimer();

        if(mqMobile.matches){
          initMobileBehavior();
        } else {
          initDesktopObserver();
        }
      }

      handleMode();

      try {
        mqMobile.addEventListener('change', handleMode);
      } catch(e) {
        mqMobile.addListener(handleMode);
      }

      document.addEventListener('shopify:section:load', function(evt){
        if (!evt || !evt.target || !evt.target.querySelector) return;
        if (!evt.target.querySelector('#' + root.id)) return;
        handleMode();
      });
    
  }
  function kvp5Boot() {
    document.querySelectorAll('[id^="kvp5-"]').forEach(initKvp5);
  }
  kvp5Boot();
  document.addEventListener('shopify:section:load', kvp5Boot);
})();
